interface IPrepareDoctorNameParams {
  firstName?: string | null;
  lastName?: string | null;
  middleName?: string | null;
  professionType?: string | null;
  title?: string | null;
}

export const prepareDoctorName = ({
  title,
  firstName,
  middleName,
  lastName,
  professionType,
}: IPrepareDoctorNameParams) => {
  let name = '';

  if (title) {
    name += title;
  }
  if (firstName) {
    name += ` ${firstName}`;
  }
  if (middleName) {
    name += ` ${middleName}`;
  }
  if (lastName) {
    name += ` ${lastName}`;
  }
  if (professionType) {
    name += ` - ${professionType}`;
  }

  return name;
};
